import React from 'react';
import styled from 'styled-components';
import { config } from './../../config/config';
const { colorConfig } = config();

const HeaderGreenDiv = styled.header`
  color: white;
  background: ${colorConfig.header};
  display: flex;
  align-items: center;
  padding: 30px;
  margin: 10px 0px;

  .logo { flex: 1; }
  .logo img { height: 50px; }
  .title {
     font-size: 28px;
     font-weight: 600;
     font-family: 'Ubuntu',arial;
     color: white;
     text-align: right;
  }

  @media(max-width: 1024px) {
    height: 60px;
    .logo img { height: 30px; }
    .title { font-size: 22px; }
  }
  @media(max-width: 800px) {
      .title { font-size: 18px; }
  }
  @media(max-width: 480px) {
    height: 28px;
    .logo img { height: 20px; }
    .title { font-size: 12px; }
  }
`;

export const Header = ({ inFrame, title = 'Product feature calculators' }) => {
  if (inFrame) return false;
  return (
    <HeaderGreenDiv>
      <div className="logo">
        <a href='https://advisers.more2life.co.uk/'>
          <img src="images/logo-white.png" alt='' />
        </a>
      </div>
      <div className="title">
        {typeof title === 'object' ? title.map(t => <div key={t}>{t}</div>) : title}
      </div>
    </HeaderGreenDiv>
  );
};


export const ContentHeader = styled.div`
  color: white;
  margin-top: 10px;
  border-radius: 5px;
  background: ${props => props.color || colorConfig.header};
  text-align: center;
  font-family: 'Ubuntu',arial;

  display: flex;

  .label {
    margin-left: 20px; margin-right: 20px; line-height: 40px; text-align: center;
    font-size: 16px;
    font-family: 'Ubuntu',arial;
    font-weight: bold;
    padding: 6px 0px;
  }
  .gap { width: 30px; }
`;



// WEBPACK FOOTER //
// ./src/components/Calculators/Header.js